'use strict';

var GridTooltipDataService = function GridTooltipDataService(BookingMatrixTooltip, BookingsIntakeTooltip, LastAdjustmentTooltip, InformationTooltip, RefreshedDataTooltip, LastYearValueTooltip, AppliedAlertScoresTooltip, TopAlertsTooltip, FlightTagsTooltip, SystemStatusUsersListTooltip, UserActionTooltipFactory, DynamicPricingAdjustmentsTooltipFactory, AdaptiveReoptTooltip, featureToggleService) {
  var bookingMatrixTooltip = new BookingMatrixTooltip();
  var bookingsIntakeTooltip = new BookingsIntakeTooltip();
  var lastAdjustmentTooltip = new LastAdjustmentTooltip();
  var informationTooltip = new InformationTooltip();
  var refreshedDataTooltip = new RefreshedDataTooltip();
  var lastYearValueTooltip = new LastYearValueTooltip();
  var appliedAlertScoresTooltip = new AppliedAlertScoresTooltip();
  var topAlertsTooltip = new TopAlertsTooltip();
  var flightTagsTooltip = new FlightTagsTooltip();
  var systemStatusUsersListTooltip = new SystemStatusUsersListTooltip();
  var userActionTooltipFactory = new UserActionTooltipFactory();
  var dynamicPricingAdjustmentsTooltipFactory = new DynamicPricingAdjustmentsTooltipFactory();
  var adaptiveReoptTooltip = new AdaptiveReoptTooltip();
  var MAPPED_MODE = featureToggleService.isEnabled('MAPPED_MODE');
  var TOOLTIP_DATA_MAP = {
    'booking-matrix-market-tooltip': bookingMatrixTooltip.getBuilder('market-screen'),
    'booking-matrix-flight-tooltip': bookingMatrixTooltip.getBuilder(),
    'bookings-intake-tooltip': bookingsIntakeTooltip.getBuilder(MAPPED_MODE),
    'last-adjustment-tooltip': lastAdjustmentTooltip.getBuilder(),
    'information-tooltip': informationTooltip.getBuilder(),
    'refreshed-data-tooltip': refreshedDataTooltip.getBuilder(),
    'last-year-value-tooltip': lastYearValueTooltip.getBuilder(),
    'top-alerts-tooltip': topAlertsTooltip.getBuilder(),
    'applied-alert-scores-tooltip': appliedAlertScoresTooltip.getBuilder(),
    'flight-tags-tooltip': flightTagsTooltip.getBuilder(),
    'user-action-tooltip': userActionTooltipFactory.getBuilder(),
    'system-status-users-list': systemStatusUsersListTooltip.getBuilder(),
    'pricing-length-of-stay-dp-adjustments': dynamicPricingAdjustmentsTooltipFactory.getBuilder(),
    'adaptive-reopt-tooltip': adaptiveReoptTooltip.getBuilder()
  };
  function getTooltipData(cellData, wholeGridData) {
    return TOOLTIP_DATA_MAP[cellData.tooltip] ? TOOLTIP_DATA_MAP[cellData.tooltip](cellData, wholeGridData) : '';
  }
  return {
    getTooltipData: getTooltipData
  };
};
GridTooltipDataService.$inject = ['BookingMatrixTooltipFactory', 'BookingsIntakeTooltipFactory', 'LastAdjustmentTooltipFactory', 'InformationTooltipFactory', 'RefreshedDataTooltipFactory', 'LastYearValueTooltipFactory', 'AppliedAlertScoresTooltipFactory', 'TopAlertsTooltipFactory', 'FlightTagsTooltipFactory', 'SystemStatusUsersListTooltipFactory', 'UserActionTooltipFactory', 'DynamicPricingAdjustmentsTooltipFactory', 'AdaptiveReoptTooltipFactory', 'FeatureToggleService'];
module.exports = GridTooltipDataService;